module.exports = __webpack_public_path__ + "media/images/flags/32/Saint-Martin-55ea37934300b7e933830e036f518285.png";